import { render } from "./disk_pack.vue?vue&type=template&id=38355ba8"
import script from "./disk_pack.vue?vue&type=script&lang=js"
export * from "./disk_pack.vue?vue&type=script&lang=js"

import exportComponent from "/root/qzf/src/kaipiao-admin-web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__